import { lang as langSV } from './sv-se';
import { lang as langEN } from './en';


/**
 * Lanagues supported.
 * They must be the same as set by language dropdown in site settings in WP.
 * Note, the keys must be in lowercase!
 */
export const translations: Record<string, Record<TranslationKeys, string>> = {
    'sv-se': langSV,
    'en': langEN,
};

/**
 * Translation keys to be used in the translation files.
 * Note, the keys must be in lowercase!
 * If you add a new key, it must be added to all translation files as well or it will fail to compile.
 */
export enum TranslationKeys {
    'show' = 'show',
    'hide' = 'hide',
    'content-for' = 'content-for',
    'submenu-for' = 'submenu-for',
    'follow-us-on' = 'follow-us-on',
    'written-by' = 'written-by',
    'all' = 'all',
    'load-more' = 'load-more',
    'filter-on' = 'filter-on',
    'minute-read' = 'minute-read',
    'form-sent' = 'form-sent',
    'form-error' = 'form-error',
    'accept-terms' = 'accept-terms',
    'is-required' = 'is-required',
    'last-name-invalid' = 'last-name-invalid',
    'first-name-invalid' = 'first-name-invalid',
    'email-invalid' = 'email-invalid',
    'zip-code-invalid' = 'zip-code-invalid',
    'phone-invalid' = 'phone-invalid',
    'see-our-projects' = 'see-our-projects',
    'news' = 'news',
    'press' = 'press',
    'close-menu' = 'close-menu',
    'find-something-good' = 'find-something-good',
    'search-hint' = 'search-hint',
    'found' = 'found',
    'hits' = 'hits',
}